import React from "react";
import useModalStore from "../../zustandStores/useModalStore";
import PremiumPopup from "../PremiumPopup";
import ButtonGroup from "../ButtonGroup";
import { modalStateValues, modalType, PREMIUM_JOB } from "../../services/constants";
import { premiumJobLabel } from "../JobType/v2/constants";
import { getDraftPayload } from "../JobPostingv2/utils";
import useSingleJobSkus from "../../zustandStores/singleJobSkus";
import useMetaLabels from "../../hooks/metaLabels";
import usePremiumJobCreditsBreakUp from "../../hooks/premiumJobCreditsBreakUp";
import { PerksDrawbackProps } from "components/JobType/v2/PerksDrawback";
import PostJobViewV2 from "../PostJobViewV2";
import LogService from "services/LogService";
import CREDIT_EVENTS from "utils/CreditEvents";

const PostPremiumJobV2 = (): JSX.Element => {
  const { modalData, setModalData } = useModalStore(state => ({
    modalData: state.modalData,
    setModalData: state.setModalData
  }));

  // Get data from draft payload instead of useJobPostingStore
  const draftPayload = getDraftPayload();
  const categoryId = draftPayload.category_id;
  const cityId = draftPayload.job_city_id;

  const { premiumSku } = useSingleJobSkus((state: any) => ({
    premiumSku: state.premiumSku
  }));
  
  const { isSpecialPrice } = usePremiumJobCreditsBreakUp({
    cityId,
    categoryId
  });
  
  const { cityId: metaCityId = null, categoryId: metaCategoryId = null } =
    premiumSku;
    
  const { cityLabel, categoryLabel } = useMetaLabels({
    cityId: metaCityId,
    categoryId: metaCategoryId
  });
  
  const { heading, state, callback, closeCallback, subHeading } = modalData;
  const { open } = modalStateValues;
  const isPopupOpen = state === open;
  
  const onClose = () => {
    setModalData({
      ...modalData,
      type: "",
      state: modalStateValues.CLOSE
    });
    if (closeCallback) closeCallback();
  };
  
  const defaultSubHeading = isSpecialPrice
    ? `${categoryLabel} jobs in ${cityLabel} are available at a special price.`
    : "";
  const popupSubHeading = subHeading ?? defaultSubHeading;
  
  const perksDrawbackList: PerksDrawbackProps = {
    list: [
      {
        type: "perk",
        value: "High number of direct applies"
      },
      {
        type: "perk",
        value: "High number of database matches"
      },
      {
        type: "perk",
        value: "Increased job reach"
      },
      {
        type: "perk",
        value: "Get noticed by an urgent hiring tag"
      }
    ]
  };

  const onJobPostError = (errorObj: any) => {
    const { details } = errorObj;
    if (details.job_post_eligibilty) {
      // setJobLeftCount(details.job_post_eligibilty);
      return;
    }
    if (details.BLACKLISTED_JOB_POSTING_BLOCKED) {
      LogService.log(CREDIT_EVENTS.BLACKLIST_REC_JOB_POST_POP_UP_SHOWN);
      useModalStore.getState().setModalData({
        view: "JOB",
        state: "open",
        type: modalType.BLACKLISTED_REC_JOB_POST_POP_UP_V2,
        onCloseButtonClick: () => {
          LogService.log(CREDIT_EVENTS.BLACKLIST_REC_JOB_POST_POP_UP_DISMISS);
          useModalStore.getState().setModalData({
            view: "",
            state: "close",
            type: ""
          });
        }
      });
    }
  };

  return (
    <PremiumPopup
      heading={heading}
      open={isPopupOpen}
      subHeading={popupSubHeading}
      onClose={onClose}
      cityId={cityId}
      categoryId={categoryId}
      perksDrawbackList={perksDrawbackList}
      renderButtons={() => {
        return (
          <ButtonGroup>
            <PostJobViewV2
              classes="w-full"
              jobPlan={PREMIUM_JOB}
              successCallback={callback}
              errorCallback={onJobPostError}
            >
              Post a {premiumJobLabel}
            </PostJobViewV2>
          </ButtonGroup>
        );
      }}
    />
  );
};

export default PostPremiumJobV2; 